import "./LoadingComponent.css";

const LoadingComponent = () => {
  return <div className="loader" />;
};

export default LoadingComponent;
